import { ReactElement, useEffect } from 'react';
import { useField, useForm } from 'react-final-form';

type SwitchInputWrapperProps = {
  children: ReactElement;
};

export const InputCheckboxInitializer = ({ children }: SwitchInputWrapperProps): ReactElement => {
  const { change } = useForm();
  const isVatLiable = useField<boolean>('isVatLiable');

  useEffect(() => {
    change('isVatLiable', Boolean(isVatLiable.input.value));
  }, [change, isVatLiable]);

  return children;
};
